import { GitHubProvisioningStatus } from '@gql/gql-types';

import { Assessment, GitHubProvisioning } from './gihub-coding-page';

export enum GitHubCodingStep {
  AssessmentNotStarted = 0,
  AssessmentStarted = 1,
  InvitationAccepted = 2,
  CodeSubmitted = 3,
  AssessmentCompleted = 4,
}

export enum GitHubCodingStepStatus {
  Pending,
  Completed,
}

export type RefetchFn = (options: {
  withGitHubSync?: boolean;
}) => Promise<void>;

export const getStepStatus = (
  stepIndex: number,
  currentStepIndex: number,
): GitHubCodingStepStatus => {
  if (stepIndex <= currentStepIndex) {
    return GitHubCodingStepStatus.Completed;
  }
  return GitHubCodingStepStatus.Pending;
};

// Maps the more fine-grained provisioning status to the UI steps
export const getCurrentStep = (
  assessment: Assessment,
  provisioning?: GitHubProvisioning | null,
): GitHubCodingStep => {
  if (assessment.completedAt) {
    return GitHubCodingStep.AssessmentCompleted;
  }
  if (!assessment.startedAt) {
    return GitHubCodingStep.AssessmentNotStarted;
  }

  switch (provisioning?.status) {
    case GitHubProvisioningStatus.Started:
    case GitHubProvisioningStatus.RepoCreated:
    case GitHubProvisioningStatus.UserInviteSent:
      return GitHubCodingStep.AssessmentStarted;
    case GitHubProvisioningStatus.UserInviteAccepted:
      return GitHubCodingStep.InvitationAccepted;
    case GitHubProvisioningStatus.UserPushedCode:
      return GitHubCodingStep.CodeSubmitted;
    case GitHubProvisioningStatus.Completed:
      return GitHubCodingStep.AssessmentCompleted;
    default:
      // Stay at first step if error or no provisioning yet
      return GitHubCodingStep.AssessmentNotStarted;
  }
};
